import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vueConfig from 'vue-config'
import config from './config'

router.beforeEach((to, from, next) => {
  $('#modifications-modal').modal('hide')
  next()
})

document.addEventListener('deviceready', function () {
  Vue.use(vueConfig, config)
  Vue.config.productionTip = false

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})

Vue.use(vueConfig, config)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
